import { type CountryCode } from 'libphonenumber-js';

/**
 * Country set used for outbound voice/SMS blocks (callee, transfer destinations, SMS recipient).
 * Centralized so widening the scope (e.g. add UK) is a one-line change.
 */
export const OUTBOUND_CALL_AND_SMS_ALLOWED_COUNTRIES: CountryCode[] = ['US', 'CA'];
